module.exports = __webpack_public_path__ + "img/image-title1.558faf52.png";